import { Injectable } from '@angular/core';
import { LocalStoreData, LocalStoreService, SessionRepository } from '@frontend-site/shared/core';

@Injectable({ providedIn: 'root' })
export class LocalStoragePersister<T extends LocalStoreData> {
    constructor(protected readonly localStore: LocalStoreService, protected readonly session: SessionRepository) {}

    set(key: string, data: T): void {
        if (!key) {
            throw new Error(`key cannot be undefined (value: '${key}')`);
        }

        if (!data) {
            throw new Error(`data cannot be undefined (value: '${data}')`);
        }

        const qualifiedKey = this.getFullyQualifiedStorageKey(key);
        this.localStore.saveData(qualifiedKey, data);
    }

    get(key: string): T | null {
        const qualifiedKey = this.getFullyQualifiedStorageKey(key);
        return this.localStore.getData<T>(qualifiedKey);
    }

    private getFullyQualifiedStorageKey(key?: string): string {
        const prefix = `${this.session.applicationConfig?.user.email}.`;
        const verfiedKey = this.verifyKey(key);
        return `${prefix}${verfiedKey}`;
    }

    private verifyKey(storageKey?: string): string {
        if (!storageKey) {
            return '';
        }

        if (storageKey.startsWith('.')) {
            storageKey = storageKey.substring(1);
        }

        return storageKey;
    }
}
